import React from "react";
import "./BlankPage.scss";

export const BlankPage = ({ children }) => {
  return (
    <div className="BlankPage">{children}</div>
  );
};
